/** 教师端 H5 选科：本会话内已确认团队上下文（用于详情返回列表时跳过选团队页） */
export const H5_TEACHER_GAOKAO_SCHOOL_GATE_SESSION = "h5_teacher_gaokao_school_gate_session_v1";

/** 教师端 H5 登录后待选择团队的临时登录上下文 */
export const H5_TEACHER_GAOKAO_PENDING_TEAM_LOGIN = "h5_teacher_gaokao_pending_team_login_v1";

/** 验证码登录选校临时凭证（与 pending 并存，防止 pending 丢失后无法选校） */
export const H5_TEACHER_GAOKAO_CHOSE_TOKEN = "h5_teacher_gaokao_chose_token_v1";

/** 本账号在本浏览器通过「创建团队」成功过的 team/school id 列表（JSON number[]） */
export const H5_TEACHER_CREATED_TEAM_IDS = "h5_teacher_created_team_ids_v1";

/** 老师邀请链：目标团队 id（任务所属 schoolId） */
export const H5_TEACHER_INVITE_TARGET_TEAM = "h5_teacher_invite_target_team_v1";

/** 老师邀请链：登录后回跳路径 */
export const H5_TEACHER_INVITE_REDIRECT = "h5_teacher_invite_redirect_v1";
